import { render } from "./AwardShift.vue?vue&type=template&id=b6a43ce2"
import script from "./AwardShift.vue?vue&type=script&lang=js"
export * from "./AwardShift.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__